module.exports = __webpack_public_path__ + "img/empty-step-three.6b77d695.svg";